import React, { useState } from 'react';
import { Pencil } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../utils/api';
import { fecha } from '../pages/agencia/ui';

/* La fecha de vencimiento de un cobro, editable donde sea que se muestre.

   Estaba resuelto solo en la pantalla de Cobros, así que desde el detalle de
   Finanzas o desde la ficha del cliente la fecha era un texto muerto. Vive acá
   para que sea la misma en todos lados y no haya que acordarse de replicarla.

   Se puede cambiar en cualquier estado, incluso en un cobro ya pagado: a veces
   la fecha que quedó registrada es la que está mal. */

export default function Vencimiento({ cobro, onCambio, children }) {
  const [editando, setEditando] = useState(false);
  const [valor, setValor] = useState('');
  const [guardando, setGuardando] = useState(false);

  const vencido = ['pendiente', 'vencido'].includes(cobro.estado)
    && cobro.habilitado !== 0
    && cobro.vencimiento
    && String(cobro.vencimiento).slice(0, 10) < new Date(Date.now() - 3 * 3600 * 1000).toISOString().slice(0, 10);

  const abrir = () => { setValor(String(cobro.vencimiento || '').slice(0, 10)); setEditando(true); };

  const guardar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      await api.put('/agency/cobros/' + cobro.id, { vencimiento: valor || null });
      toast.success('Vencimiento actualizado');
      setEditando(false);
      if (onCambio) onCambio(valor);
    } catch { toast.error('No se pudo guardar'); }
    finally { setGuardando(false); }
  };

  return (
    <>
      <button className="celda-editable" title="Cambiar el vencimiento" onClick={abrir}
        style={{ color: vencido ? '#ef4444' : 'inherit' }}>
        {children || fecha(cobro.vencimiento)}<Pencil size={11} />
      </button>

      {editando && (
        <div className="modal-overlay" onClick={() => setEditando(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 400 }}>
            <h2>Cambiar el vencimiento</h2>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', margin: '4px 0 16px' }}>
              {cobro.cliente ? cobro.cliente + ' · ' : ''}{cobro.concepto || cobro.servicio || 'Cobro'}
            </p>
            <form onSubmit={guardar}>
              <div className="form-group"><label>Vence el</label>
                <input type="date" value={valor} autoFocus onChange={e => setValor(e.target.value)} /></div>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-secondary" onClick={() => setEditando(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary" disabled={guardando}>Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
